const apiV1Base = (import.meta.env.VITE_API_BASE || '/api/v1').replace(/\/+$/, '');

export const API = {
  wikiBase: `${apiV1Base}/wiki`,
  authBase: `${apiV1Base}/auth`,
};

export const STORAGE_KEYS = {
  authToken: 'ackordion_auth_token',
  authAccount: 'ackordion_auth_account',
  pendingProposals: 'ackordion_pending_proposals',
  uiLocale: 'ackordion_ui_locale',
};

export const LOCALE = {
  defaultCode: 'en',
};

export const SITE = {
  title: 'BLACK HORIZON 1908',
  brandPrimary: 'BLACK HORIZON',
  brandSecondary: '1908',
};

export const ASSETS = {
  storyCover: new URL('./assets/story-cover.png', import.meta.url).href,
};

export const LIMITS = {
  pageLimit: 100,
  sidebarRecentLimit: 10,
  proposalLimit: 50,
  maxStoredProposals: 12,
  titleMaxLength: 512,
};

export const GRAPH = {
  size: 300,
  knownRadius: 90,
  missingRadius: 126,
};

export const MAP = {
  defaultWidth: 800,
  defaultHeight: 600,
  minRadius: 4,
  maxRadius: 18,
  radiusScale: 1.5,
  labelMinRadius: 10,
  labelFont: '11px Inter, sans-serif',
  linkDistance: 80,
  charge: -120,
  collideGap: 4,
  alphaDecay: 0.028,
  zoomMin: 0.1,
  zoomMax: 8,
  // CSS-token fallbacks used when getComputedStyle returns an empty string (e.g. SSR, test).
  fallbackColors: {
    ink: '#17221f',
    muted: '#66736f',
    crimson: '#9b2432',
  },
  // Legend-friendly palette for category colour-coding; distinct against the parchment background.
  palette: [
    '#2563eb', // blue
    '#16a34a', // green
    '#d97706', // amber
    '#7c3aed', // violet
    '#db2777', // pink
    '#0891b2', // cyan
    '#ea580c', // orange
    '#65a30d', // lime
    '#9333ea', // purple
    '#0d9488', // teal
  ],
};

export const MAP_PREVIEW = {
  nodeCount: 80,
  width: 480,
  height: 260,
  alphaDecay: 0.15,
  tickCount: 200,
};

export const ROLES = {
  contributor: 'contributor',
  moderator: 'moderator',
  admin: 'admin',
  superadmin: 'superadmin',
};

export const SCOPES = {
  adminOwnership: 'admin',
};
